import { useState, useEffect } from 'react';

interface TOCItem {
  id: string;
  level: number;
  text: string;
}

interface ArticleTOCProps {
  items: TOCItem[];
}

export default function ArticleTOC({ items }: ArticleTOCProps) {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: 0.1 }
    );

    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [items]);

  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav className="sticky top-24" aria-label="文章目录">
      <h4 className="text-sm font-semibold text-foreground-800 mb-3 flex items-center gap-2">
        <i className="ri-list-unordered text-base"></i> 目录
      </h4>
      <ul className="space-y-1.5 border-l-2 border-background-200">
        {items.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => handleClick(item.id)}
              className={`block text-left text-xs w-full py-1 transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                item.level === 2 ? 'pl-4' : 'pl-7'
              } ${
                activeId === item.id
                  ? 'text-primary-500 border-l-2 border-primary-500 -ml-0.5 font-medium'
                  : 'text-foreground-500 hover:text-foreground-700'
              }`}
            >
              {item.text}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}